export default __webpack_public_path__ + "static/media/mockup-opim.3a4b44ec.png";